import {Loader} from '@mantine/core';
import {WhiteBgButton} from '@packages/ui';
import type React from 'react';
import type {IClipContentProps, IClipListProps} from './ClipListInterfaces';

export const ClipListBase: React.FC<
  IClipListProps & {
    ClipContentComponent: React.ComponentType<IClipContentProps>;
  }
> = ({
  clips,
  hasNextPage,
  isFetching,
  isFetchingNextPage,
  loadMoreClips,
  ClipContentComponent,
}) => (
  <>
    <ul className="bg-white">
      {clips.map((clip, i) => (
        <ClipContentComponent key={`${clip.content.title}-${i}`} clip={clip} />
      ))}
    </ul>
    {hasNextPage && (
      <div className="mt-16 flex justify-center">
        <WhiteBgButton
          label="もっと見る"
          isDisabled={!hasNextPage || isFetching}
          isPrimary={false}
          isLarge={false}
          onClick={() => {
            loadMoreClips();
          }}
          className="w-[80%]"
        />
      </div>
    )}
    {(isFetching || isFetchingNextPage) && (
      <div className="flex justify-center py-24">
        <Loader color="gray" size="lg" />
      </div>
    )}
  </>
);
